import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actions as JobActions, selectors as JobSelectors } from "store/modules/jobs";
import TableComponent from "../TableComponent";

const UnFilledPage = (props) => {
  const dispatch = useDispatch();
  const pageInfo = useSelector(JobSelectors.getTomorrowUnfilledPaginationData)
  const jobListData = useSelector(JobSelectors.getListData({ timeframe: 'tomorrow', status: 'unfilled', part: "data" }))
  const pageFilter = useSelector(JobSelectors.getListData({ timeframe: 'tomorrow', status: 'unfilled', part: "filter" }))
  const pageSort = useSelector(JobSelectors.getListData({ timeframe: 'tomorrow', status: 'unfilled', part: "sort" }))
  const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
    dispatch(JobActions.setTomorrowUnfilledPageSize(pageSize));
    dispatch(JobActions.setTomorrowUnfilledFilter(filters));
    dispatch(JobActions.setTomorrowUnfilledSort(sortBy));
    dispatch(JobActions.fetchTomorrowUnfilledJobs(pageIndex));
  }, []);

  return <TableComponent pageInfo={pageInfo} jobListData={jobListData} pageFilter={pageFilter} pageSort={pageSort} fetchData={fetchData} history={props.history}/>
}

export default UnFilledPage